import { useSetAtom } from "jotai";
import {
  redoAtom,
  saveCanvasAsyncCommand,
  undoAtom,
} from "@zapier/canvas-state";
import { useEffect } from "react";

export function useBindUndoRedoKeyboardShortcuts() {
  const undo = useSetAtom(undoAtom);
  const redo = useSetAtom(redoAtom);
  const saveToBackend = useSetAtom(saveCanvasAsyncCommand);

  useEffect(() => {
    const keyDownHandler = async (event: KeyboardEvent) => {
      if (
        event.key === "z" &&
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey
      ) {
        // Prevent the browser's native undo/redo so text inputs and stuff
        // don't undo along with the canvas history
        event.preventDefault();
        const futureState = redo();
        if (futureState) {
          saveToBackend(futureState);
        }
      } else if (event.key === "z" && (event.ctrlKey || event.metaKey)) {
        // Prevent the browser's native undo/redo so text inputs and stuff
        // don't undo along with the canvas history
        event.preventDefault();
        const pastState = undo();
        if (pastState) {
          saveToBackend(pastState);
        }
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [undo, redo, saveToBackend]);
}
